import { CampaignFeed, FinishedCampaignFeed } from "@/components/campaign-feed";
import {
  LoggedOutState,
  NoActiveCampaigns,
  NoCampaigns,
  NoFinishedCampaigns,
} from "@/components/campaigns/tournament/no-active-campaigns";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { Loader } from "@/components/loader";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import { collectCampaignEntries } from "@/campaigns";
import { useAppStore } from "@/stores";
import { useStoreWithEqualityFn } from "zustand/traditional";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const { t } = useTranslation();
  const authenticated = useAppStore((s) => s.authenticated);
  // Loading tracks the shared `campaigns` stream — type-agnostic by design.
  const loading = useAppStore((s) => s.campaignsStream.loading);
  const hasActive = useStoreWithEqualityFn(
    useAppStore,
    (s) => collectCampaignEntries(s, "active").length > 0,
    Object.is
  );
  const hasFinished = useStoreWithEqualityFn(
    useAppStore,
    (s) => collectCampaignEntries(s, "finished").length > 0,
    Object.is
  );

  if (loading) {
    return (
      <div className="h-96 w-full">
        <Loader />
      </div>
    );
  }

  if (!hasActive && !hasFinished) {
    return authenticated ? <NoCampaigns /> : <LoggedOutState />;
  }

  return (
    <>
      {/* Mobile Layout */}
      <div className="relative flex h-auto w-full flex-col items-center justify-baseline lg:hidden">
        <Tabs
          defaultValue="active"
          className="relative h-full w-full bg-transparent"
        >
          <TabsList className="sticky top-0 z-20 bg-background pt-4">
            <TabsTrigger value="active">
              {t("general.homeMobileNavigation.active")}
            </TabsTrigger>
            <TabsTrigger value="finished">
              {t("general.homeMobileNavigation.completed")}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="active" className="z-0">
            {hasActive ? (
              <CampaignFeed variant="mobile" />
            ) : (
              <NoActiveCampaigns />
            )}
          </TabsContent>
          <TabsContent value="finished" className="z-0">
            {hasFinished ? <FinishedCampaignFeed /> : <NoFinishedCampaigns />}
          </TabsContent>
        </Tabs>
      </div>

      {/* Desktop Layout */}
      <div
        className={cn(
          "hidden h-auto w-full flex-col items-start justify-baseline border-y border-secondary bg-background lg:flex"
        )}
      >
        {hasActive ? (
          <>
            <Typography tag="h5" className="mt-4 ml-4 text-primary">
              {t("general.activeCampaigns", "Active")}
            </Typography>
            <CampaignFeed variant="desktop" />
          </>
        ) : (
          <NoActiveCampaigns />
        )}
        {hasFinished ? (
          <>
            <Typography tag="h5" className="mt-4 ml-4 text-muted-foreground">
              {/* The same key the mobile tab uses, so desktop and mobile never disagree about
                  what this section is called. */}
              {t("general.homeMobileNavigation.completed", "Completed")}
            </Typography>
            <FinishedCampaignFeed />
          </>
        ) : null}
      </div>
    </>
  );
};
